exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kv-filter-period {\n  display: inline-flex;\n  flex-direction: column;\n}\n.kv-remove-filter {\n  cursor: pointer;\n  display: flex;\n}\ni.glyphicon.glyphicon-calendar.fa.fa-calendar {\n  display: none;\n}\n", ""]);

// exports
